export const projectColors = {
  backGrey: '#D9D9D9',
  textBlue: '#35A9EA',
  orange: '#FFC43D',
  overlay: 'rgba(0, 0, 0, 0.55)',
  white: '#FFFFFF',
  blue: '#67F1E8',
  purple: '#9138D3',
  barGreen: '#26D037',
  flashyGreen: '#38D363',
  wrongRed: '#CF0808',
  nameOrange: '#FFBF1A',
  lightGrey: '#BDBDBD',
  darkGrey: '#37474F',
  whiteish: '#F9F8F4',
  funnelBg: '#fdf3e6',
  backGround: '#F4F9F9',
  primary: {
    black: '#5E32A6',
    darkest: '#8C4AF8',
    accent: '#9B5FFF',
    darker: '#A36FF9',
    dark: '#B991FB',
    neutral: '#CFB4FC',
    medium: '#DBC7FD',
    light: '#E6D8FE',
    lighter: '#F6F1FE',
    lightest: '#FDFBFF',
  },
  red: {
    darkest: '#f10d1e',
    dark: '#D9663A',
    neutral: '#F87F4A',
    medium: '#F38B93',
    light: '#f8c9cb',
    lightest: '#fff4f5',
  },
  danger: {
    dark: '#A60915',
    neutral: '#f10d1e',
  },
  green: {
    dark: '#1DB954',
    darker: '#12813D',
    darkest: '#007F2D',
    neutral: '#06D6A0',
    medium: '#8FE3A8',
    light: '#D4FADC',
    lightest: '#f2fffb',
  },
  secondary: {
    darkest: '#354BB3',
    darker: '#39395B',
    neutral: '#5438DC',
    dark: '#7082CD',
    medium: '#5267C0',
    light: '#A9B8E9',
    lighter: '#C6D4F6',
    lightest: '#E8F0FF',
    black: '#1831A5',
    space: '#090129',
    night: '#1A0B47',
  },
  avatar: {
    teal: '#0097A5',
    blue: '#1E99EB',
    yellow: '#F4B627',
    pink: '#E6449C',
    green: '#26A167',
    coral: '#EA665B',
  },
  cards: {
    rare: '#8C9EDB',
    holoPink: '#FF46A0',
    holoYellow: '#FFD23C',
    holoMint: '#50FFB4',
    holoBlue: '#46AAFF',
    holoViolet: '#B45AFF',
    goldBronze: '#B07830',
    goldBrown: '#5C3428',
  },
  structural: {
    darkest: '#070732',
    darker: '#39395B',
    dark: '#6A6A84',
    neutral: '#9C9CAD',
    light: '#CDCDD6',
    lighter: '#EBEBEF',
    lightest: '#FAFAFB',
  },
  warning: {
    black: '#805900',
    gold: '#DCAD0A',
    goldEdge: '#D8AA2D',
    goldLight: '#FDDB51',
    goldBright: '#FFDC4A',
    flash: '#FFE100',
    darkest: '#FF8A00',
    darker: '#FFA726',
    dark: '#FFC43D',
    neutral: '#F8CD18',
    light: '#FFD76D',
    lighter: '#FFEEB5',
    lightest: '#FFF9E8',
    cream: '#FFFFBD',
  },
  paywall: {
    lightest: {
      from: '#F4EEFC',
      via: '#FBECF6',
      to: '#FEF9F2',
    },
    darkest: {
      from: '#9B5FFF',
      to: '#B358DC',
    },
  },
  'lesson-header': {
    from: '#9B5FFF',
    to: '#B358DC',
  },
  halloween: {
    from: '#FF6B35',
    to: '#FF8E53',
  },
  neutral: {
    green: '#2DD08D',
    darkGreen: '#014026',
  },
  worldcup: {
    medium: '#666EFE',
    light: '#646DFC',
    dark: '#081C80',
    darkest: '#001676',
    // 3★ green
    green: '#43C230',
    greendark: '#0A4E22',
    grass: '#57B145',
  },
  summer: {
    gold: '#F5B841',
  },
  easter: {
    sky: '#9EDDFF',
    green: '#A4CE60',
  },
  streak: {
    freeze: '#24CAF8',
    flame: '#F24813',
  },
  blingz: {
    neutral: '#F84AAB',
  },
  badge: {
    bronze: '#F87F4A',
    bronzeLight: '#FEEAE2',
    silver: '#5267C0',
    silverLight: '#E8F0FF',
    gold: '#FFC43D',
    goldDark: '#805900',
    goldLight: '#FFEEB5',
    diamond: '#35A9EA',
    diamondLight: '#EAF6FC',
  },
};

export const projectGradients = {
  purpleShine: `linear-gradient(124deg, ${projectColors.primary.light} 16.27%, ${projectColors.primary.lighter} 31.16%, ${projectColors.primary.lighter} 44.3%, ${projectColors.primary.light} 57.1%, ${projectColors.primary.light} 62.37%, ${projectColors.primary.lighter} 74.67%, ${projectColors.primary.lighter} 82.52%, ${projectColors.primary.light} 91.93%)`,
};
